<template>
    <div>
        <el-dialog
            :title="$t('res.addKnowledge')"
            :visible.sync="visible"
            width="600px"
            custom-class="dialog-addKnowledge"
            :append-to-body="true"
            :close-on-click-modal="false">
            <!-- trainee dialog -->
            <trainee-dialog :traineeDialog.sync="traineeDialog"
                            :selectedTable="knowForm.whiteLists"
                            :filterType="2"
                            :notStudent="true"
                            @dialog-save="traineeDialogSave"
            ></trainee-dialog>

            <el-form
                :model="knowForm"
                :rules="topicRules"
                class="know-form"
                ref="knowForm"
                :label-width="$i18n.locale === 'zh-CN' ? '120px': '180px'">

                <div class="select-group">
                    <el-form-item :label="$t('res.knowName')" prop="name">
                        <el-input v-model="knowForm.name" :placeholder="$t('tip.knowNameTip')" :disabled="dialogType == 3" clearable></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('res.knowType')" prop="categoryID">
                        <el-select v-model="knowForm.categoryID" :disabled="dialogType == 3" :placeholder="$t('c.select')" style="width:220px;">
                            <el-option :label="item.value" :value="item.id" v-for="item in knowledgeTypeMenu"
                                    :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('res.knowTag')" prop="tags">
                        <el-input v-model="knowForm.tags" :disabled="dialogType == 3" :placeholder="$t('tip.knowTagTip')" clearable></el-input>
                    </el-form-item>
                    <p class="tag-tip" v-if="dialogType != 3"><i class="nucfont inuc-exclamation-circle"></i> {{$t('res.knowTagTip')}}</p>
                    <el-form-item label="上传文件" prop="resourceID">
                        <div class="file-area">
                            <div class="file-item add-btn" :title="$t('res.upload')" @click="uploadFile" v-if="!knowFile.resourceID && dialogType != 3">
                                <i class="nucfont inuc-add"></i>
                            </div>
                            <div class="file-item" v-if="knowFile.upFileID > 0">
                                <el-progress  :text-inside="true" :stroke-width="13"
                                    :percentage="Math.round(knowFile.upProgress*100)"></el-progress>
                            </div>
                            <div class="file-item file-show" v-if="knowFile.resourceID">
                                <img v-if="imageAttr.indexOf(knowFile.extension) > -1"
                                    class="upload-image"
                                    :src="knowFile.resURL" alt="thumbnail"
                                >
                                <!-- 文档 -->
                                <a v-if="textAttr.indexOf(knowFile.extension) > -1" class="document">
                                    <span class="res-document-excel"
                                        v-if="knowFile.extension==='.xls'||knowFile.extension==='.xlsx'"></span>
                                    <span class="res-document-pdf"
                                        v-else-if="knowFile.extension==='.pdf'"></span>
                                    <span class="res-document-ppt"
                                        v-else-if="knowFile.extension==='.ppt'||knowFile.extension==='.pptx'"></span>
                                    <span class="res-document-txt"
                                        v-else-if="knowFile.extension==='.txt'"></span>
                                    <span class="res-document-word"
                                        v-else-if="knowFile.extension==='.doc'||knowFile.extension==='.docx'"></span>
                                    <span class="res-document-undefined"
                                        v-else></span>
                                </a>
                                <a v-if="audioAttr.indexOf(knowFile.extension) > -1" class="document">
                                    <span class="res-audio"></span>
                                </a>
                                <a v-if="videoAttr.indexOf(knowFile.extension) > -1" class="document">
                                    <span class="res-video"></span>
                                </a>

                                <h3>{{knowFile.reName}}</h3>

                                <span class="upload-item-actions" v-if="dialogType != 3" :title="$t('c.delete')">
                                    <span
                                        class="upload-item-delete"
                                        @click="handleRemove"
                                    >
                                    <i class="nucfont inuc-delete"></i>
                                    </span>
                                </span>
                            </div>
                            <p></p>
                        </div>
                    </el-form-item>
                    <p class="tag-tip" v-if="dialogType == 3"><i class="nucfont inuc-exclamation-circle"></i> 请点击知识库管理列表中知识名称或图标查看文件</p>
                    <el-form-item :label="$t('res.visibleRange')" prop="isPublic">
                        <el-radio-group v-model="knowForm.isPublic" :disabled ="dialogType == 3">
                            <el-radio :label="true">{{$t('res.allSee')}}</el-radio>
                            <el-radio :label="false">{{$t('res.someSee')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="!knowForm.isPublic" :label="$t('res.visiblePerson')" prop="participants" class="item-participants">
                        <div class="trainee">
                            <el-tag size="mini" @close="deleteUser(index)" v-for="(item, index) in knowForm.whiteLists" :key="item.userID" :closable="dialogType != 3">{{item.userName}}</el-tag>
                        </div>
                        <el-button v-if="dialogType != 3" @click="addUser" type="primary" circle size="small" title="添加可见人员"><i class="nucfont inuc-add"></i></el-button>
                    </el-form-item>

                    <el-form-item :label="$t('res.knowDesc')" prop="description">
                        <el-input type="textarea"
                                v-model="knowForm.description"
                                :disabled="dialogType == 3"
                                :autosize="{ minRows: 2, maxRows: 4}"></el-input>
                    </el-form-item>
                </div>
            </el-form>
            <div id="uploadPanel" style="display: none">
                <uploader ref="uploader"
                        :options="options"
                        :autoStart="false"
                        @file-added="onFileAdded"
                        @file-progress="onFileProgress"
                        @file-success="onFileSuccess"
                        @file-error="onFileError"
                        class="uploader-example">
                    <uploader-btn id="uploadFile" :attrs="fileAttr">
                        文件上传
                    </uploader-btn>
                    <uploader-list>
                        <div class="file-panel" slot-scope="props">
                            <ul class="file-list">
                                <li v-for="file in props.fileList"
                                    :key="file.id">
                                    <uploader-file :file="file" :list="true" ref="file"></uploader-file>
                                </li>
                            </ul>
                        </div>
                    </uploader-list>
                </uploader>
            </div>
            <div slot="footer" v-if="dialogType != 3" style="text-align: center;margin-bottom: 10px">
                <el-button type="primary" @click="saveKnowForm" :loading="knowLoading">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {Ticket} from '@/utils';
    import api from '@/api';
    import traineeDialog from '@components/Dialog/TraineeDialog'
    import {ACCEPT_CONFIG} from '@/config/constant';
    import SparkMD5 from 'spark-md5';
    const MAX_SIZE = 10;

    export default {
        props: {
            knowledgeDialog: Boolean,
            knowData: {
                type: Object
            },
            dialogType:{
                type: String
            }
        },
        components: {traineeDialog},
        data() {
            return {
                visible: false,
                knowForm: {
                    name: '',
                    description: '',
                    categoryID: '',
                    isPublic: true,
                    tags: '',
                    resourceID: '',
                    whiteLists: []
                },
                cascadeProp: {
                    value: 'id',
                    label: 'value',
                    children: 'children'
                },
                topicRules: {
                    name: [
                        {required: true, message: this.$t('tip.knowNameTip'), trigger: 'blur'},
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'}
                    ],
                    categoryID: [
                        {required: true, message: this.$t('tip.knowTypeTip'), trigger: 'change'}
                    ],
                    isPublic: [{required: true}],
                    resourceID: [{required: true}],
                    tags: [
                        {max: 100, message: this.$t('rule.maxLength', ['100']), trigger: 'blur'},
                    ],
                    description: [
                        {max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'},
                    ],
                },
                difficultyDict: [],
                traineeDialog: false,
                knowLoading: false,
                fileAttr:{accept:ACCEPT_CONFIG.getSome()},
                options: {
                    target: api.simpleUploadURL,
                    chunkSize: '2048000',
                    fileParameterName: 'upfile',
                    testChunks: true,     //是否开启秒传
                    maxChunkRetries: 3,
                    //generateUniqueIdentifier:function(){return "987654321"},
                    checkChunkUploadedByResponse: function (chunk, message) {
                        var objMessage = JSON.parse(message);
                        if (objMessage.skipUpload) {
                            return true;
                        }
                        return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0
                    },
                    headers: {
                        Authorization: Ticket.get() && "Bearer " + Ticket.get().access_token
                    },
                },
                fileList: [],
                knowFile: {
                    reName:'',
                    resourceID: 0,
                    resURL: '',
                    upFileID: 0,
                    upProgress: 0,
                    fileType: 0,
                    extension: '',
                },
                imageAttr: ACCEPT_CONFIG.image,
                textAttr:  ACCEPT_CONFIG.document,
                videoAttr:ACCEPT_CONFIG.video,
                audioAttr: ACCEPT_CONFIG.audio,
                knowledgeID: ''
            }
        },
        created() {
            this.$store.dispatch('getKnowledgeTypeMenu');
        },
        computed: {
            ...mapGetters([
                'knowledgeTypeMenu',
            ]),
            //Uploader实例
            uploader() {
                return this.$refs.uploader.uploader;
            },
        },
        methods: {
            initDialog() {
                this.$nextTick(() => {
                    this.clearForm()
                    if(this.knowData){
                        this.knowledgeID = this.knowData.id
                        this.knowForm.name = this.knowData.name
                        this.knowForm.description = this.knowData.description
                        this.knowForm.categoryID = this.knowData.categoryID
                        this.knowForm.isPublic = this.knowData.isPublic
                        this.knowForm.tags = this.knowData.tags
                        this.knowForm.resourceID = this.knowData.resourceID
                        this.knowForm.whiteLists = []
                        if (this.knowData.whiteLists){
                            this.knowData.whiteLists.forEach(item => {
                                this.knowForm.whiteLists.push({
                                    userID: item.userID,
                                    userName: item.userName
                                })
                            })
                        }
                        this.knowForm.whiteLists = this.knowData.whiteLists ? this.knowData.whiteLists : []
                        if (this.knowData.resource) {
                            this.knowFile.reName = this.knowData.resource.name
                            this.knowFile.resourceID = this.knowData.resource.id
                            this.knowFile.fileType = this.knowData.resource.type

                            this.knowFile.resURL = this.knowData.resource.entity.url
                            this.knowFile.extension = this.knowData.resource.extension
                        }
                    }
                })
            },
            addUser() {
                this.traineeDialog = true
            },
            deleteUser(n) {
                this.knowForm.whiteLists.splice(n, 1)
            },
            traineeDialogSave(data) {
                this.knowForm.whiteLists = []
                data.forEach(item => {
                    this.knowForm.whiteLists.push({
                        userID: item.id,
                        userName: item.name
                    })
                })

                this.traineeDialog = false;
                this.$refs["knowForm"].validateField('whiteLists');
            },
            //清空文件重新上传
            handleRemove(){
                this.knowFile = {
                    reName:'',
                    resourceID: 0,
                    resURL: '',
                    upFileID: 0,
                    upProgress: 0,
                    fileType: 0,
                    extension: ''
                }
            },
            //上传
            onFileAdded(file) {
                // let item = this.chapters[this.currentChapter].sections[this.currentSection]
                this.knowFile.upFileID = file.id
                this.knowFile.reName = file.name
                let rename = file.name
                this.knowFile.extension = rename.substring(rename.lastIndexOf('.'), rename.length)

                this.computeMD5(file);
            },
            /**
             * 计算md5，实现断点续传及秒传
             * @param file
             */
            computeMD5(file) {
                let fileReader = new FileReader();
                let time = new Date().getTime();
                let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
                let currentChunk = 0;
                const chunkSize = 10 * 1024 * 1000;
                let chunks = Math.ceil(file.size / chunkSize);
                let spark = new SparkMD5.ArrayBuffer();

                // this.statusSet(file.id, 'md5');
                file.pause();

                loadNext();

                fileReader.onload = (e => {
                    spark.append(e.target.result);

                    if (currentChunk < chunks) {
                        currentChunk++;
                        loadNext();

                        this.$nextTick(() => {
                            $(`.myStatus_${file.id}`).text(this.$t('res.checkMD5') +' '+ ((currentChunk/chunks)*100).toFixed(0)+'%')
                        })
                    } else {
                        let md5 = spark.end();
                        this.computeMD5Success(md5, file);
                        console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`);
                    }
                });

                fileReader.onerror = function () {
                    this.error(`文件${file.name}读取出错，请检查该文件`)
                    file.cancel();
                };

                function loadNext() {
                    let start = currentChunk * chunkSize;
                    let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;

                    fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
                }
            },

            computeMD5Success(md5, file) {
                // 将自定义参数直接加载uploader实例的opts上
                Object.assign(this.uploader.opts, {
                    query: {
                        culture: this.$i18n.locale,
                        'ui-culture': this.$i18n.locale
                    },
                    headers: {
                        Authorization: Ticket.get() && "Bearer " + Ticket.get().access_token
                    },
                })

                file.uniqueIdentifier = md5;
                file.resume();
            },

            onFileProgress(pro){
                this.knowFile.upProgress = pro._prevProgress
            },
            onFileSuccess(rootFile, file, response, chunk) {
                let res = JSON.parse(response)
                if (res.needMerge) {
                    api.mergeSimpleUpload({
                        tempName: res.tempName,
                        fileName: file.name,
                        totalChunks: res.totalChunks
                    }).then(res => {
                        if (res.status === 0) {
                            this.knowFile.upFileID = 0
                            this.knowFile.upProgress = 0
                            this.knowFile.resourceID = res.resourceID
                            this.knowFile.resURL = res.url
                        } else if (res.status === 1) {
                            console.log('上传失败')
                        } else if (res.status === 2) {
                            this.knowFile.upFileID = 0
                            this.knowFile.upProgress = 0
                            this.knowFile.resourceID = res.resourceID
                            this.knowFile.resURL = res.url
                        }
                    })
                } else {
                    this.knowFile.upFileID = 0
                    this.knowFile.upProgress = 0
                    this.knowFile.resourceID = res.resourceID
                    this.knowFile.resURL = res.url
                }
            },
            onFileError(rootFile, file, response, chunk) {
                this.$message({
                    message: this.$t('course.fileUploadFail'),
                    type: 'error'
                })
            },
            uploadFile() {
                $('#uploadFile').click()
            },
            saveKnowForm(){
                this.knowForm.resourceID = this.knowFile.resourceID
                this.$refs['knowForm'].validate((valid) => {
                    if (!valid) return
                    if(!this.knowFile.resourceID){
                        this.$message({
                            message: '请上传文件！',
                            type: 'error'
                        })
                        return
                    }
                    if(!this.knowForm.isPublic){
                        if(this.knowForm.whiteLists.length == 0){
                            this.$message({
                                message: '请选择可见人员！',
                                type: 'error'
                            })
                            return
                        }
                    }
                    let submitData = {...this.knowForm}
                    this.knowLoading = true
                    if (this.knowledgeID) {
                        api.editAsset(this.knowledgeID, submitData).then(res => {
                            this.knowLoading = false
                            this.success('edit')
                            this.$emit('addSaveOver')
                            this.visible = false
                        }).catch(error => this.knowLoading = false);
                    } else {
                        api.postAsset(submitData).then(res => {
                            this.knowLoading = false
                            this.success('add')
                            this.$emit('addSaveOver')
                            this.visible = false
                        }).catch(error => this.knowLoading = false)
                    }
                })
            },
            success(type = 'operate') {
                let _msg = {
                    add: this.$t('m.addSuccess'),
                    edit: this.$t('m.editSuccess'),
                    del: this.$t('m.delSuccess'),
                    operate: this.$t('m.operateSuccess')
                };
                this.$message({
                    message: _msg[type],
                    type: 'success'
                })
            },
            clearForm() {
                this.$refs['knowForm'] && this.$refs['knowForm'].resetFields()
                this.knowledgeID = ''
                this.knowForm.whiteLists = []
                this.handleRemove()
            }
        },
        watch: {
            knowledgeDialog() {
                this.visible = this.knowledgeDialog
            },
            visible(bool) {
                if (!bool) {
                    // this.$emit('update:knowledgeDialog', false)
                    this.$emit('onDialogClosed', false);
                    // this.clearForm();
                }else{
                    this.initDialog()
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
@import '../../../style/const';
.select-group{
    padding-right:50px;
}
.item-participants {
    .trainee {
        min-height: 100px;
        max-height: 200px;
        padding: 5px;
        line-height: 30px;
        border: 1px solid #DCDFE6;
        border-radius: 4px;
        overflow-y: auto;
        .el-tag {
            margin-left: 10px;
        }
    }
    button {
        position: absolute;
        top: 50%;
        margin-top: -16px;
        right: -50px;
    }
}
.tag-tip{
    padding-left: 80px;
    color: #22B9FF;
    font-size: 12px;
    margin-top: -10px;
    margin-bottom: 10px;
    .nucfont{
        font-size: 12px;
    }
}
.file-area{
    width: 130px;
    height: 130px;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    margin: 0 8px 8px 0;

    .file-item {
        width: 100%;
        height: 100%;
        text-align: center;

        &.add-btn{
            cursor: pointer;
            line-height: 130px;
            &:hover{
                background-color: rgba(0,0,0,.5);
                transition: opacity .3s;
                border-radius: 6px;
                >i{
                    color: #fff;
                }
            }
            >i{
                color: #999;
            }

        }

        > h3 {
            padding: 0 5px;
            font-size: 12px;
            line-height: 1.4;
            @include no-wrap
        }

        &.file-show{
            &:hover{
                .upload-item-actions{
                    opacity:1
                }
            }

        }

        .upload-item-actions {
            position: absolute;
            width: 130px;
            height: 130px;
            left: 0;
            top: 0;
            cursor: default;
            text-align: center;
            color: #fff;
            line-height:130px;
            opacity: 0;
            font-size: 20px;
            border-radius:6px;
            background-color: rgba(0,0,0,.5);
            transition: opacity .3s;
            .upload-item-delete{
                cursor: pointer;
            }
        }

    }

    .upload-image{
        width: 100%;
        height: 100px;
        object-fit: cover;
    }

    .document {
        display: block;
        padding: 10px;
        height: 100px;

        > span {
            display: block;
            height: 100%;
        }

        .res-document-excel {
            background: url('../../../assets/images/document/excel.png') center no-repeat;
            background-size: contain;
        }

        .res-document-pdf {
            background: url('../../../assets/images/document/pdf.png') center no-repeat;
            background-size: contain;
        }

        .res-document-ppt {
            background: url('../../../assets/images/document/ppt.png') center no-repeat;
            background-size: contain;
        }

        .res-document-txt {
            background: url('../../../assets/images/document/txt.png') center no-repeat;
            background-size: contain;
        }

        .res-document-undefined {
            background: url('../../../assets/images/document/undefined.png') center no-repeat;
            background-size: contain;
        }

        .res-document-word {
            background: url('../../../assets/images/document/word.png') center no-repeat;
            background-size: contain;
        }
        .res-audio {
            background: url('../../../assets/images/course/audio.png') center no-repeat;
            background-size: contain;
        }
        .res-video {
            background: url('../../../assets/images/course/video.png') center no-repeat;
            background-size: contain;
        }
    }

}
</style>
